module.exports = __webpack_public_path__ + "img/home_img_weixin_nor.e61d740c.png";